// extracted by mini-css-extract-plugin
export default {"photo":"photo--HHGjD","group":"group--tOmgn"};